import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { FormatService } from './_services/app-formatservice';
import * as moment from 'moment-mini-ts';

export class FormDateFormatter extends NgbDateParserFormatter {

  fail: string = "";

  constructor(private formatService: FormatService) {
    super();
  }

  parse(value: string): NgbDateStruct {
    if (value && this.formatService.format) {
      const d = moment(value, this.formatService.format);
      return { year: d.year(), month: (d.month() + 1), day: d.date() };
    }
    return null ?? {} as NgbDateStruct;
  }

  format(date: NgbDateStruct): string {
    if (date && this.formatService.format) {
      const result = moment().year(date.year).month(date.month - 1).date(date.day).format(this.formatService.format);
      return result;
    }
    return null??"";
  }

}
